import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { ALL_CHARTS_TAB_ID } from "../constants";
import { renderDashboardChart } from "../utils/renderDashboardChart";
import {
  DASHBOARD_CHART_CONTENT_MAX_WIDTH,
  DASHBOARD_PAGE_BG,
  dashboardChartsContentCardSx,
  dashboardChartsGridGap,
  dashboardChartsPlainContentSx,
  dashboardChartsSectionSpacing,
  dashboardChartsTitleSx,
  dashboardChartTileCardSx,
} from "../dashboardChartStyles";
import { DashboardChartTabSelector } from "./DashboardChartTabSelector";
import { DashboardChartFilters } from "./DashboardChartFilters";
import { ChartTileTitle } from "./ChartTileTitle";

export function DashboardChartsView({
  charts,
  safeTabIndex,
  isAllChartsView,
  selectorTabs,
  setSelectedTabIndex,
  goToChartTab,
}) {
  const activeChart = !isAllChartsView && safeTabIndex > 0 ? charts[safeTabIndex - 1] : null;
  const alignFiltersToChartWidth = activeChart?.singleViewSurface === "plain";

  return (
    <Stack spacing={dashboardChartsSectionSpacing} sx={{ width: "100%", bgcolor: DASHBOARD_PAGE_BG }}>
      <Typography component="h2" sx={dashboardChartsTitleSx}>
        Grafici
      </Typography>

      <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
        <DashboardChartTabSelector tabs={selectorTabs} selectedIndex={safeTabIndex} onChange={setSelectedTabIndex} />
      </Box>

      <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
        <DashboardChartFilters alignToChartWidth={alignFiltersToChartWidth} />
      </Box>

      {isAllChartsView ? (
        <Box
          role="tabpanel"
          id={`dashboard-chart-panel-${ALL_CHARTS_TAB_ID}`}
          aria-labelledby={`dashboard-chart-tab-${ALL_CHARTS_TAB_ID}`}
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" },
            gap: dashboardChartsGridGap,
          }}
        >
          {charts.map((chartDef, idx) => (
            <Paper key={chartDef.id} elevation={0} sx={dashboardChartTileCardSx}>
              <ChartTileTitle title={chartDef.title} onClick={() => goToChartTab(idx)} />
              {renderDashboardChart(chartDef, idx, { embedInGrid: true, onOpenChartTab: goToChartTab })}
            </Paper>
          ))}
        </Box>
      ) : (
        <>
          {charts.map((chartDef, i) => {
            const chartTabIndex = i + 1;
            const active = safeTabIndex === chartTabIndex;
            const usePlainSurface = chartDef.singleViewSurface === "plain";
            const surfaceSx = usePlainSurface ? dashboardChartsPlainContentSx : dashboardChartsContentCardSx;

            return (
              <Box
                key={chartDef.id}
                component={usePlainSurface ? "div" : Paper}
                elevation={0}
                role="tabpanel"
                id={`dashboard-chart-panel-${chartDef.id}`}
                aria-labelledby={`dashboard-chart-tab-${chartDef.id}`}
                hidden={!active}
                sx={{
                  ...surfaceSx,
                  display: active ? "flex" : "none",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <Box sx={{ width: "100%", maxWidth: DASHBOARD_CHART_CONTENT_MAX_WIDTH }}>
                  {active ? renderDashboardChart(chartDef, i) : null}
                </Box>
              </Box>
            );
          })}
        </>
      )}
    </Stack>
  );
}
